<div
  id="common-focus-announcement"
  aria-live="assertive"
  role="alert"
  class="hidden-content-announcement"
>
  {{ announcementMessage }}
</div>
